module.exports = __webpack_public_path__ + "static/img/tab-service-center-v1.afd13ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/tab-service-center-v1.png
// module id = 4wdC
// module chunks = 0